export default __webpack_public_path__ + "static/media/particles-2.9e39a52b.svg";